/**
 * Main Entry Point
 *
 * Initializes the app, auth, and renders the root component.
 */

import { render } from 'preact';
import { App } from './App';
import { initAuth } from './stores/auth';
import { initTheme, initResponsive, initTabFromUrl, setAppLoading } from './stores/ui';

// Initialize app
async function init() {
  // Initialize UI helpers
  initTheme();
  initResponsive();
  initTabFromUrl();

  // Get app container and clear loading state
  const appEl = document.getElementById('app');
  if (appEl) {
    // Remove loading class and clear loading content
    appEl.classList.remove('app-loading');
    appEl.innerHTML = '';
  }

  // Render app
  render(<App />, document.getElementById('app')!);

  // Initialize auth in background
  try {
    await initAuth();
  } catch (e) {
    console.error('Auth initialization failed:', e);
  }

  // App is ready
  setAppLoading(false);
}

// Start the app
init();
